<template>
  <b-modal
    id="signin-real-person"
    hide-footer
    hide-header
    no-stacking
    @shown="firstShow"
  >
    <template v-slot:default="{ hide }">
      <!-- Close Button Container -->
      <div class="close-button-container">
        <span class="close-button" @click="hide()">&times;</span>
      </div>
      <!-- End Close Button Container -->

      <!-- Modal Main Content -->
      <div class="modal-main-content">
        <!-- Logo -->
        <div class="logo">
          <img src="@/assets/images/logo.png" alt="roshd logo" />
        </div>
        <!-- End Logo -->
        <!-- Title -->
        <div class="heading mb-4">
          <h6>ورود حامیان</h6>
        </div>
        <!-- End Title -->

        <!-- Form -->
        <form @submit.prevent="boroToo">
          <div
            class="form-group position-relative"
            :class="{ 'form-group--error': $v.nationalCode.$error }"
          >
            <!--   <input type="text" name="national_code" class="form-control username-with-combo" placeholder="نام کاربری">-->
            <!--   <div class="combo-box">-->
            <!--       <select>-->
            <!--           <option value="nation_code">کد ملی / شماره پاسپورت</option>-->
            <!--           <option value="mobile">شماره موبایل</option>-->
            <!--       </select>-->
            <!--   </div>-->
            <input
              ref="nationalCode"
              v-model.trim="nationalCode"
              @input="delayTouch($v.nationalCode)"
              type="text"
              name="national_code"
              class="form-control"
              placeholder="نام کاربری (کدملی / شماره پاسپورت)"
            />

            <div class="error" v-if="!$v.nationalCode.required">
              فیلد نام کاربری الزامی است.
            </div>

            <!-- <div class="combo-box second-combo-box d-none">
              <select>
                <option value="98">+98</option>
                <option value="4">+4</option>
              </select>
            </div>-->
          </div>
          <div
            class="form-group mb-2 input-password-type position-relative"
            :class="{ 'form-group--error': $v.password.$error }"
          >
            <i
              class="icon-eye"
              @mousedown="showPassword = 'text'"
              @mouseup="showPassword = 'password'"
              @mouseleave="showPassword = 'password'"
            ></i>
            <input
              :type="showPassword"
              name="password"
              v-model.trim="password"
              class="form-control"
              @input="delayTouch($v.password)"
              placeholder="رمز عبور"
            />

            <div class="error" v-if="!$v.password.required">
              وارد نمودن رمز عبور الزامی است.
            </div>
            <div
              class="error"
              v-if="!$v.password.minLength && $v.password.persianWordCheck"
            >
              رمز عبور باید حداقل هشت کاراکتر باشد.
            </div>
            <div class="error" v-if="!$v.password.persianWordCheck">
              کیبورد شما فارسی است!
            </div>
          </div>
          <!-- <div class="remember-me">
            <b-form-checkbox
              class="pr-0"
              size="sm"
              name="remember-me"
              v-model="rem"
            >
              <span class="text">مرا به خاطر بسپار</span>
            </b-form-checkbox>
          </div> -->

          <!-- Captcha -->
          <div class="captcha">
            <p class="font-size-12 mb-2">کد زیر را وارد کنید</p>
            <div class="captcha-box">
              <img :src="`${urlCap + captcha.img}`" alt="captcha" />
              <input
                :maxlength="captcha.max"
                ref="captchaInp"
                type="text"
                v-model="captcha.inp"
                autocomplete="off"
              />
            </div>
          </div>
          <!-- Captcha -->

          <!-- v-b-modal.signup-real-person -->

          <div class="text-center mt-4 mb-2">
            <button
              type="button"
              @click.prevent="showModalReg"
              class="bordered ml-2"
            >
              ثبت نام
            </button>

            <b-overlay
              :show="busy"
              rounded
              opacity="0.6"
              spinner-small
              spinner-variant="primary"
              class="d-inline-block"
            >
              <button type="submit" :disabled="busy" ref="button">ورود</button>
            </b-overlay>
          </div>

          <div class="forget-password text-center">
            <p v-b-modal.forget-password-real-person>
              رمز عبور را فراموش کرده ام
            </p>
          </div>
        </form>
        <!-- End Form -->
      </div>
      <!-- End Modal Main Content -->
    </template>
  </b-modal>
</template>

<script>
import axios from "@/axios";
import { formErrors, url } from "@/mixins.js";
import { required, minLength } from "vuelidate/lib/validators";
const touchMap = new WeakMap();
import { mapState } from "vuex";

export default {
  name: "SigninRealPerson",
  mixins: [formErrors, url],
  data() {
    return {
      password: "",
      showPassword: "password",
      nationalCode: "",
      rem: +false,
      busy: false,
      captcha: {
        inp: "",
        img: "",
        max: 4,
      },
    };
  },

  computed: {
    urlCap() {
      return `${this.basicUrl}assets/images/captcha/`;
    },
    ...mapState({
      user: (state) => state.user,
    }),
  },
  methods: {
    firstShow() {
      this.generateCaptcha();
    },

    showModalReg() {
      this.$root.$emit("bv::show::modal", "signup-real-person");
    },

    delayTouch($v) {
      $v.$reset();
      if (touchMap.has($v)) {
        clearTimeout(touchMap.get($v));
      }
      touchMap.set($v, setTimeout($v.$touch, 1500));
    },

    async generateCaptcha(captchaCode) {
      let captcha;

      if (!captchaCode) {
        let data = new FormData();
        data.append("action", "create_captcha");

        await axios
          .post("captcha/create.php", data)
          .then((data) => {
            console.log("generateCaptcha:", data.data);

            captcha = data.data;
          })
          .catch((err) => console.error("Error create captcha::", err));
      }

      this.captcha.img = captcha || captchaCode;
      this.captcha.img += ".png";
      this.captcha.inp = "";
    },

    async boroToo() {
      this.busy = true;
      this.$v.$touch();

      if (this.$v.$invalid) {
        setTimeout(() => {
          this.busy = false;
        }, 400);
        return;
      }

      let data = new FormData();

      data.append("action", "login");
      data.append("type", 2);
      data.append("login", this.nationalCode);
      data.append("password", this.password);
      data.append("rem", +this.rem);
      data.append("captcha", this.captcha.inp);

      await axios
        .post("user/auth/eduaid/login.php", data)
        .then((data) => {
          console.log("login:", data.data);

          switch (data.data.msg) {
            case "ip_blacklist":
              this.$snotify.info(this.errors[data.data.msg]);
              break;

            case 11:
              this.$snotify.warning(this.errors[data.data.msg]);
              setTimeout(() => {
                this.$refs.captchaInp.focus();
              }, 400);
              break;

            case "login_err":
              this.$snotify.warning(this.errors[data.data.msg]);
              break;

            case "login_err_ip_blacklist":
              this.$snotify.warning(this.errors[data.data.msg]);
              break;

            case "logged_in":
            case "already_logged_in":
              this.$snotify.success(this.errors[data.data.msg]);
              this.$store.dispatch('checkLogin');
              this.$root.$emit("bv::hide::modal", "signin-real-person");
              break;

            case "active_fail":
              this.$snotify.warning(this.errors[data.data.msg]);
              break;

            case "active_fail_ip_blacklist":
              this.$snotify.warning(this.errors[data.data.msg]);
              break;

            case "login_fail":
              this.$snotify.warning(this.errors[data.data.msg]);
              break;

            case "login_fail_ip_blacklist":
              this.$snotify.warning(this.errors[data.data.msg]);
              break;

            default:
              this.$snotify.error("خطا در برقراری ارتباط با سرور");
          }

          if (data.data.captcha) {
            this.generateCaptcha(data.data.captcha);
          }

          this.busy = false;
        })
        .catch((err) => console.error("Response error Login ::", err));
    },
  },

  validations: {
    password: {
      required,
      minLength: minLength(8),
      persianWordCheck(val) {
        let pattern = /^[^ابپتثجچحخدذرزژسشصضطظعغفقکگلمنوهیآئ]*$/g;

        return pattern.test(val);
      },
    },
    nationalCode: {
      required,
    },
  },

  watch: {},
};
</script>